import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { paymentsData } from "../../../../../data/accounting";

import Notes from "../../../../../components/common/Notes";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import ActionsLog from "../../../../../components/common/ActionsLog";
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

import "./PaymentDetails.css";
import BillPayCheck from "./BillPayCheck";
import PageHeading from "../../../../../components/common/PageHeading";

const PaymentDetailsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Enter Bill", "1", "", "", ""),
    RightBarMethod("Automated AP", "2", "", "", ""),
    RightBarMethod("Smart Bill Entry", "3", "", "", ""),
    RightBarMethod("Enter Utility Bill (RUBS)", "4", "", "", ""),
    RightBarMethod("Enter Credit", "5", "", "", ""),
    RightBarMethod("Pay Bills", "6", "", "", ""),
    RightBarMethod("Pay Management Fees", "7", "", "", ""),
    RightBarMethod("Tenant Payable", "8", "", "", ""),
    RightBarMethod("New Recurring Bill", "9", "", "", ""),
    RightBarMethod("Manually Post Bills", "10", "", "", ""),
    RightBarMethod("Upload Bulk Bills", "11", "", "", ""),
    RightBarMethod("View eCheck Payment Receipt", "12", "", "", ""),
  ]),
];

function PaymentDetails() {
  const [payment, setPayment] = useState({});

  const { id } = useParams();

  useEffect(() => {
    const newObject = paymentsData.find((item) => {
      return item.id === Number(id);
    });
    setPayment(newObject);
  }, []);

  return (
    <>
      <div className="payment-details">
        <Row gutter={[0, 14]}>
          <Col span={24}>
            <PageHeading heading="ACH" />
          </Col>
          <Col span={24}>
            <BillPayCheck data={payment.payee} />
          </Col>
          <Col span={24}>
            <Row className="header-row">
              <Col span={7}>
                <span>Property</span>
              </Col>
              <Col span={2}>
                <span>Unit</span>
              </Col>
              <Col span={5}>
                <span>Account</span>
              </Col>
              <Col span={3}>
                <span>Amount</span>
              </Col>
              <Col span={7}>
                <span>Description</span>
              </Col>
            </Row>
            {payment?.payments
              ? payment.payments.map((item, index) => {
                  return (
                    <Row className="data-row" key={index}>
                      <Col span={7}>
                        <span>{item.property}</span>
                      </Col>
                      <Col span={2}>
                        <span>{item.unit}</span>
                      </Col>
                      <Col span={5}>
                        <span>{item.account}</span>
                      </Col>
                      <Col span={3}>
                        <span>{item.amount}</span>
                      </Col>
                      <Col span={7}>
                        <span>{item.description}</span>
                      </Col>
                    </Row>
                  );
                })
              : null}
          </Col>
          {/* <Col span={24}><ActionsLog /></Col> */}
          <Col span={24}>
            {/* <Notes /> */}
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PaymentDetailsRightBar} />
      </div>
    </>
  );
}

export default PaymentDetails;
